import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/debt-register.js';
import q from '../query.js';
export const registriesEntity = 'debt-registries';
export const registriesByCaseIdKey = (caseId) => `registries-by-caseId-${caseId}`;
export const ensureRegistriesByCaseIdLoaded = (id) => q.ensureLoaded(registriesByCaseIdKey(id));
export const useRegistriesByCaseId = (caseId, casualConsistency) => q.query(registriesByCaseIdKey(caseId), () => api.getRegistries(caseId), keys.read.collection(registriesEntity), {
    enabled: caseId != null,
});
export const rkiSyncStatusKey = (runId) => `rki-sync-status-${runId}`;
export const useRkiSyncStatus = (runId) => q.query(rkiSyncStatusKey(runId), () => api.rkiSyncStatus(runId), keys.read.collection(registriesEntity), {
    enabled: runId != null,
});
export const rkiStatusSyncStatusKey = (runId) => `rki-status-sync-status-${runId}`;
export const useRkiStatusSyncStatus = (runId) => q.query(rkiStatusSyncStatusKey(runId), () => api.rkiStatusSyncStatus(runId), keys.read.collection(registriesEntity), {
    enabled: runId != null,
});
//# sourceMappingURL=index.js.map